import { useId } from 'react';

/** FE-15: a real <label> bound by id. FE-12: the API's field message renders here. */
export function Field({ label, hint, error, required, children, htmlFor, className = '' }) {
  const generated = useId();
  const id = htmlFor ?? generated;
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="label">
          {label}
          {required && <span className="ml-0.5 text-red-500" aria-hidden="true">*</span>}
        </label>
      )}

      {typeof children === 'function'
        ? children({
            id,
            'aria-describedby': [hintId, errorId].filter(Boolean).join(' ') || undefined,
            'aria-invalid': error ? 'true' : undefined,
          })
        : children}

      {hint && !error && <p id={hintId} className="mt-1.5 text-xs text-muted">{hint}</p>}
      {/* FE-14: the error carries text, not only a red border. */}
      {error && <p id={errorId} role="alert" className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
}

export default Field;
